import { useTheme } from 'foundations-theming/utils';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
// @ts-expect-error ui-addon-avatars has no types yet
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUserDisplay = styled.span.withConfig({
  displayName: "SourceUserAndAvatar__StyledUserDisplay",
  componentId: "sc-15enerc-0"
})(["font-weight:500;height:18px;line-height:18px;"]);
const Span = styled.span.withConfig({
  displayName: "SourceUserAndAvatar__Span",
  componentId: "sc-15enerc-1"
})([""]);
const Div = styled.div.withConfig({
  displayName: "SourceUserAndAvatar__Div",
  componentId: "sc-15enerc-2"
})([""]);
const SourceUserAndAvatar = ({
  user,
  isInline
}) => {
  const trellisTheme = useTheme();
  const Container = isInline ? Span : Div;
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "source-interpretation-user-tooltip",
    disabled: !user.email,
    title: user.email,
    children: /*#__PURE__*/_jsxs(Container, {
      "data-test-id": "source-interpretation-user-and-avatar",
      className: `align-center ${isInline ? 'display-inline-flex' : 'display-flex'}`,
      style: {
        height: '18px',
        color: user.gdprDeleted || user.simplyRemoved || user.deactivated ? trellisTheme.color['do-not-use-flint'] : trellisTheme.color['do-not-use-slinky']
      },
      children: [/*#__PURE__*/_jsx(UIAvatar, {
        type: "hubSpotUserEmail",
        hubSpotUserEmail: user.email,
        size: "xxs",
        textSpacing: 1,
        style: {
          margin: '0 4px'
        }
      }), /*#__PURE__*/_jsx(StyledUserDisplay, {
        children: /*#__PURE__*/_jsx(TruncateString, {
          tooltip: false,
          matchContentWidth: true,
          children: user.displayResult
        })
      })]
    })
  });
};
export default SourceUserAndAvatar;